import React, { useState } from "react";
import "./transfer.scss";
import axios from "axios";
import APP_BASE_URL from "../../components/Api/globalApi";

const TransferActivityPoint = () => {
  const [referralId, setReferralId] = useState("");
  const [loading, setLoading] = useState(false);

  const [activityPoint, setActivityPoint] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const storedUserId = localStorage.getItem("user_id");
  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");
    setLoading(true);
    try {
      const response = await axios.post(
  ` ${APP_BASE_URL}/user/transferpoint`,
        {
          referal_id: referralId,
          activity_point: Number(activityPoint),
        },
        {
          headers: {
            user_id: storedUserId, // Pass the user_id in headers
          },
        }
      );

      console.log("Response:", response.data);
      if (response.data.result) {
        setMessage("Transferred successfully!");
        alert("Transferred successfully!");
      } else {
        setMessage("failed to transfer");
        alert("failed to transfer");
      }
      window.location.reload();
    } catch (error) {
      setLoading(false);
      console.error("Error transferring points:", error);
      setError("Error transferring points. Please try again.");
      alert("Error transferring points. Please try again.");
    }
  };

  return (
    <div className="form-container">
      <h2>Submit Activity</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="referralId">Referral ID</label>
          <input
            type="text"
            id="referralId"
            value={referralId}
            onChange={(e) => setReferralId(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="activityPoint">Activity Point</label>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              type="button"
              onClick={() => {
                setActivityPoint((prev) => {
                  const newValue = Number(prev) + 1200;
                  return newValue.toString();
                });
              }}
            >
              ▲
            </button>

            <input
              type="number"
              id="activityPoint"
              value={activityPoint}
              placeholder="0"
              readOnly
              onChange={(e) => setActivityPoint(e.target.value)}
              required
              min="1200"
            />

            <button
              type="button"
              onClick={() => {
                setActivityPoint((prev) => {
                  const newValue = Math.max(1200, Number(prev) - 1200);
                  return newValue.toString();
                });
              }}
            >
              ▼
            </button>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading || !activityPoint || Number(activityPoint) < 1200}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>

      {/* Show message */}
    </div>
  );
};

export default TransferActivityPoint;
